'use client';

import clsx from 'clsx';
import { Button } from '@/shared/ui/atoms';
import type { CtaBlockProps } from './types';

export default function CtaBlock({
    title,
    text,
    subtitle,
    buttonLabel,
    onButtonClick,
    buttonIcon,
    classNames = {},
    className,
}: CtaBlockProps) {
    const copy = text ?? subtitle ?? '';
    const { root, bg, inner, title: titleClass, text: textClass, button } = classNames;
    return (
        <div className={clsx(root, className)}>
            <div className={clsx(bg)} aria-hidden />
            <div className={clsx(inner)}>
                <h3 className={clsx(titleClass)}>{title}</h3>
                {copy && (
                    <p className={clsx(textClass)}>
                        {copy}
                    </p>
                )}
                <Button
                    type="button"
                    className={clsx(button)}
                    onClick={onButtonClick}
                    startIcon={buttonIcon}
                >
                    {buttonLabel}
                </Button>
            </div>
        </div>
    );
}
